import { CodeDataEditor } from '@/components/Code/Code';
import { ExpandableErrorAlert } from '@/components/ExpandableErrorAlert';

export const ExtraParamsJsonEditor = ({
  value,
  onChange,
  error,
}: {
  value: Record<string, any>;
  onChange: (value: Record<string, any>) => void;
  error?: string;
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1 text-sm font-medium">
        Extra Parameters
        <span className="text-xs text-gray-500">
          Add or remove model parameters not shown above,{' '}
          <a
            href="https://docs.langchain.com/langsmith/managing-model-configurations#extra-parameters"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            see docs
          </a>{' '}
          for more information.
        </span>
      </div>
      <CodeDataEditor
        value={value}
        onChange={onChange}
        language="json"
        readOnly={false}
      />
      {error && <ExpandableErrorAlert error={error} />}
    </div>
  );
};
